import { isSubmissionData2026 } from "../../../reduxToolkit/submissionsSlice";
import { RequireSubmissionProvided } from "../../../wrappers/requireSubmission";
import { SubmitToSmi2026 } from "./submitToSMI/2026/submitToSmi2026";

interface SubmitToSMIProps extends RequireSubmissionProvided {
}

export function SubmitToSMI({ submission }: SubmitToSMIProps) {
  const data = submission.data
  if (data) {
    if (isSubmissionData2026(data)) {
      return <SubmitToSmi2026 submission={submission} />
    }

    throw new Error(`Unknown submission data: ${JSON.stringify(data)}`)
  }

  return <SubmitToSmi2026 submission={submission} />
}
